"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = uaDetect;

/**
 * @file uaDetect.js
 */
function uaDetect() {
  function detectSafari() {
    var ua = window.navigator.userAgent;
    var ret = ua.match(/(MSIE|(?!Gecko.+)Firefox|(?!AppleWebKit.+Chrome.+)Safari|(?!AppleWebKit.+)Chrome|AppleWebKit(?!.+Chrome|.+Safari)|Gecko(?!.+Firefox))(?: |\/)([\d.apre]+)/);
    var likeSafari = false;

    if (ret && ret[1] && ret[1].toLowerCase() === 'safari') {
      likeSafari = true;
    }

    if (likeSafari && !/CriOS|UCBrowser|fxiOS|QHBrowser|MQQBrowser|baidubrowser|MicroMessenger|SogouMobileBrowser/i.test(ua)) {
      return true;
    }

    return false;
  }

  var ua = window.navigator.userAgent;
  var isIOS = /iPhone/i.test(ua) || /iPod/i.test(ua);
  var isIOS9 = isIOS && parseInt(ua.replace(/^.*OS ([\d_]+) like.*$/, '$1').split('_')[0], 10) > 8;
  var isIOS11 = isIOS && /OS (?:11)_\d[_\d]* like Mac OS X/i.test(ua);
  var isAndroid = /android/i.test(ua);
  var isQQBrowser = /MQQBrowser/i.test(ua);
  var isWeChat = /MicroMessenger/i.test(ua);
  var isMobileQQ = /^(?!.*Safari).*QQ/.test(ua);
  var isHaoKan = /haokan(.*)/.test(ua);
  var isIOS8 = /OS (?:8)_\d[_\d]* like Mac OS X/i.test(ua);
  var isUC = /UCBrowser|UCWeb/i.test(ua);
  var isFireFox = /Firefox/i.test(ua) || /fxiOS/i.test(ua);
  var isWeibo = /weibo/i.test(ua);
  var isQQ = / qq/i.test(ua);
  var isBaiduHi = /baiduhi/i.test(ua);
  var isSafari = detectSafari();
  var isQuanmin = /bdminivideo/i.test(ua);
  var isDrama = /bddrama/i.test(ua);
  var isTieba = /tieba/i.test(ua);
  var isShouBai = /baiduboxapp/i.test(ua);
  return {
    ua: ua,
    isIOS: isIOS,
    isIOS8: isIOS8,
    isIOS9: isIOS9,
    isIOS11: isIOS11,
    isAndroid: isAndroid,
    isQQBrowser: isQQBrowser,
    isWeChat: isWeChat,
    isMobileQQ: isMobileQQ,
    isHaoKan: isHaoKan,
    isUC: isUC,
    isFireFox: isFireFox,
    isWeibo: isWeibo,
    isQQ: isQQ,
    isBaiduHi: isBaiduHi,
    isSafari: isSafari,
    isQuanmin: isQuanmin,
    isDrama: isDrama,
    isTieba: isTieba,
    isShouBai: isShouBai
  };
}